export enum LoadbalancerSetupType {
    WithoutMeasurementDevice = '/common/content/images/Without_AG.png',
    ChargersAreIncludedInPowerConsumption = '/common/content/images/With_AG_included.png',
    ChargersAreNotIncludedInPowerConsumption = '/common/content/images/With_AG_included_charger_not_included.png',
}
